import { Component, Input, OnInit } from "@angular/core";
import { uploadFiles, validateFiles } from "src/app/shared/upload-files";
import { MessageService } from "primeng/api";

@Component({
    selector: "app-custom-attribute",
    templateUrl: "./custom-attribute.component.html",
    styleUrls: ["./custom-attribute.component.scss"],
})
export class CustomAttributeComponent implements OnInit {
    @Input()
    customFields;

    allowedExtensions = [".png", ".jpg", ".jpeg", ".gif"]; // For the attachment files

    constructor(private messageService: MessageService) {}

    ngOnInit(): void {}

    checkRequired(name) 
    {
        return this.customFields.find((el) => el.name === name)?.isRequired || false;
    }

    setCheckBoxValue(value) 
    {
        const checkBox = [];
        value.forEach((element) => {
            const val = { name: element };
            checkBox.push(val);
        });
        return checkBox;
    }

    onCustomUpload(files: File[], field) 
    {
        if (typeof Worker !== undefined) 
        {
            for (let file of files) 
            {
                let errors = validateFiles(file, 4, this.allowedExtensions);
                if (errors.length > 0) 
                {
                    for (let error of errors) 
                    {
                        this.messageService.add({
                            severity: "error",
                            summary: "Error",
                            detail: error.fileName + ": " + error.error,
                        });
                    }
                } 
                else 
                {
                    uploadFiles(file, ({ name, content, size, extension }) => 
                    {
                        let attachment = {
                            name: name,
                            content: content,
                            extension: extension,
                            sizeInBytes: size,
                        };
                        field.customUploadedFiles.push(attachment);
                    });
                }
            }
        } 
        else 
        {
            this.messageService.add({
                severity: "error",
                summary: "Error",
                detail: "Please update the browser. Web Workers are not supported in the older versions of this browser.",
            });
        }
    }
}
